<div class="card-event-header">
    @if (resolvedImage(); as image) {
        <sirius-image-item
            class="card-event-image"
            [image]="image"
            [autocrop]="true"
            fit="cover"
            [imageData]="resolvedImageData()"
            alt="" />
    }
    @if (resolvedAttributes().length) {
        <sirius-chips
            class="card-event-attributes"
            [chips]="resolvedAttributes()"
            [ariaLabel]="'card.event.attributes' | translate" />
    }
</div>

<div class="card-event-body">
    <a
        class="card-event-link"
        [siriusLink]="resolvedLink()"
        [attr.aria-describedby]="linkDescribedBy()"
        (linkSelect)="onClick()">
        <sirius-heading [text]="resolvedTitle()" textStyleCategory="title" textStyleSize="s" [h]="3" />
    </a>

    <dl class="card-event-meta">
        @if (resolvedDateLabel(); as dateLabel) {
            <div class="card-event-meta-item">
                <dt
                    class="card-event-label sir-text-style-paragraph-s-bold"
                    [textContent]="'page.event.date' | translate"></dt>
                <dd class="card-event-value" [id]="dateId">
                    @if (resolvedDate(); as date) {
                        <time [attr.datetime]="date">{{ dateLabel }}</time>
                    } @else {
                        {{ dateLabel }}
                    }
                </dd>
            </div>
        }
        @if (resolvedLocation(); as location) {
            <div class="card-event-meta-item">
                <dt
                    class="card-event-label sir-text-style-paragraph-s-bold"
                    [textContent]="'page.event.location' | translate"></dt>
                <dd class="card-event-value" [id]="locationId">{{ location }}</dd>
            </div>
        }
        @if (languageList(); as languages) {
            <div class="card-event-meta-item card-event-languages">
                <dt
                    class="card-event-label sir-text-style-paragraph-s-bold"
                    [textContent]="'page.event.language' | translate"></dt>
                <dd class="card-event-value">{{ languages }}</dd>
            </div>
        }
    </dl>

    @if (resolvedTags().length) {
        <sirius-chips class="card-event-tags" [chips]="resolvedTags()" [ariaLabel]="'card.event.tags' | translate" />
    }
</div>
